import axios from 'axios';
import { getToken } from './auth';

import { API_URL } from './config';

export const changePassword = async (passwordData) => {
  try {
    const token = getToken();
    const response = await axios.post(`${API_URL}/auth/change-password`, passwordData, {
      headers: { Authorization: `Bearer ${token}` },
      withCredentials: true
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Error changing password');
  }
};